const IS_PRODUCTION = process.env.REACT_APP_PROD_FLAG == "true";

export function selectMode(forProduction, forStage) {
    return IS_PRODUCTION ? forProduction : forStage;
}
